import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import {Card, CardActions, CardText} from "material-ui/Card";
import { questionsForSection } from "../reducer";
import QuestionPrompt from "../components/QuestionPrompt";
import QuestionPageHeader from "../components/QuestionPageHeader";
import {
  toggleQuestionFlagged,
  saveAnswer,
  saveAnswerNote
} from "../actions/response";
import { getResponse, calculateResults } from "../reducer/response";
import QuestionNoteInlineEditor from "../components/QuestionNoteInlineEditor";
import Dialog from "material-ui/Dialog";
import { putResponse } from "../actions/sync";
import LinearProgress from "material-ui/LinearProgress";
import BackgroundSyncStatusBar from "../components/BackgroundSyncStatusBar";
import {fetchTranslation} from '../actions/translation';
import {FormattedMessage, injectIntl} from "react-intl";

class QuestionPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      noteModalOpen: false || (
        !!props.answer &&
            !!props.answer.note &&
            props.answer.note.length > 0
      ),
      waitForSave: false,
      offline: false
    }
    this.promptRef = React.createRef()
  }

  componentDidMount() {
    window.addEventListener('online',  this.updateOnlineState);
    window.addEventListener('offline',  this.updateOnlineState);
    this.updateOnlineState();

    if(this.props.response.userEdits.trIDForResponse && this.props.response.userEdits.trIDForResponse !== -1 && !this.props.translation){
      this.props.fetchTranslation(this.props.response.userEdits.trIDForResponse)
    }
  }

  updateOnlineState = (e) => {
    this.setState({offline: !navigator.onLine})
  }

  componentWillUnmount() {
    window.removeEventListener('online',  this.updateOnlineState);
    window.removeEventListener('offline',  this.updateOnlineState);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.answer && newProps.answer.note && newProps.answer.note.length > 0) {
      this.setState({noteModalOpen: true});
    }
  }

  downloadData = () => {
    const data = "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(this.props.response));
    const a = document.createElement('a');
    a.setAttribute("href", data);
    a.setAttribute("download", "fishpath-response.json");
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  render() {
    if(this.props.leavingQuestionPage){return(null);}
    let props = this.props;
    const intl = props.intl;
    const { isFinishing } = this.props;
    let question = props.question || {
      title: "Question",
      description: "Description.",
      answers: [
        {
          title: "yes",
          id: 1
        }
      ]
    };

    let trQuestion;
    if(props.response.userEdits.trIDForResponse > 0 && props.translation){
      trQuestion = props.translation.questions.find(q => q.engID === question.id)
    }

    let answer = props.answer ? props.answer.value : false;
    let hasCaveats = Object.keys(props.question.domainLogic.caveats).length > 0;
    let hasCriteria = Object.keys(props.question.domainLogic.criteria).length > 0;
    let cavOrCritText = intl.formatMessage({ id:"questionPage.criteriaQuestion", defaultMessage:"Criteria" })
    if(hasCaveats && hasCriteria){
      cavOrCritText = intl.formatMessage({id:"questionPage.bothCavCritQuestion", defaultMessage:"Both Criteria and Caveats"})
    } else if(hasCaveats){
      cavOrCritText = intl.formatMessage({id:"questionPage.caveatQuestion", defaultMessage:"Caveats"})
    }

    return (
      <Card style={{ maxWidth: 800, margin: "0 auto", marginBottom: 40 }}>
        <BackgroundSyncStatusBar hidden={false} />
        <QuestionPageHeader
          section={props.section}
          category={props.category}
          numQuestions={props.totalQuestionsInSection}
          numAnswers={props.totalAnswersInSection}
          position={props.position}
          flagged={props.answer ? !!props.answer.flagged : false}
          onToggleFlagged={props.toggleFlagged.bind(
            null,
            question.id,
            this.props.response,
            this.props.sectionID
          )}
          cavOrCritText={cavOrCritText}
          hasNote={
            !!props.answer &&
            !!props.answer.note &&
            props.answer.note.length > 0
          }
          onTakeNote={this.handleTakeNote}
          isFinishing={isFinishing}
          translation={props.translation}
        />
        <QuestionPrompt
          ref="prompt"
          section={props.section}
          {...question}
          answer={answer}
          onChange={this.onAnswerChange.bind(this)}
          trQuestion={trQuestion}
        />
        <QuestionNoteInlineEditor
          ref={c => (this.noteEditor = c)}
          open={
            this.state.noteModalOpen
          }
          question={question}
          defaultValue={props.answer ? props.answer.note : ""}
          onChange={this.handleSaveNote}
          onRequestClose={this.handleCloseNote}
          key={question.id}
        />
        <CardActions
          style={{
            textAlign: "center",
            paddingRight: 50,
            paddingBottom: 20
          }}
        >
          <FlatButton onClick={this.onPrevious} label={intl.formatMessage({id:"questionPage.previous", defaultMessage:"Previous"})} />
          <RaisedButton
            onClick={this.onNext.bind(this)}
            label={
              intl.formatMessage({id:"question.nextBtn", defaultMessage:"{isLastQuestion, select, true {Finish Section} other {Next Question}}"}, {isLastQuestion: this.props.isLastQuestion})
            }
            primary={true}
          />
        </CardActions>
        <Dialog
          open={this.state.waitForSave}
          title={intl.formatMessage({id:"questionPage.saving", defaultMessage:"Saving answers"})}
          actions={[
            <FlatButton
              label={intl.formatMessage({id:"questionPage.download" , defaultMessage:"Download Data"})}
              onClick={this.downloadData}
            />,
            <RaisedButton
              primary={true}
              label={intl.formatMessage({id:"general.retry", defaultMessage:"Retry"})}
              disabled={!this.state.saveErrors}
              onClick={this.retrySaveResponse}
            />
          ]}
        >
          {!this.state.saveErrors && <LinearProgress mode="indeterminate" />}
          {this.state.saveErrors && (
            <React.Fragment>
              <CardText>An error occurred while attempting to save your answers. <b>Do not refresh your browser or you will lose your work.</b> It's likely that a network issue is preventing you from contacting the FishPath server. Please check your internet connection and press "Retry" below to save your work.</CardText>
              <CardText style={{color: 'red'}}>{this.state.saveErrors}</CardText>
              <CardText>Network Status: {this.state.offline ? "Offline ❌" : "Online 👍"}</CardText>
              <CardText>If all else fails, you can download your data with the button below. Send this to <a target="_blank" rel="noopener noreferrer" href="mailto:support@fishpath.org">support@fishpath.org</a> for debugging and recovery. Please also include a screenshot of this error message.</CardText>
            </React.Fragment>
          )}
        </Dialog>
      </Card>
    );
  }

  handleTakeNote = () => {
    this.setState({ noteModalOpen: !this.state.noteModalOpen });
  };

  handleCloseNote = () => {
    this.setState({ noteModalOpen: false });
  };

  onNext() {
    this.saveNoteIfExists();
    let value = this.refs.prompt.getValue();
    this.setState({ noteModalOpen: false });
    if (!value) {
      alert(
        this.props.intl.formatMessage({id:"questionPage.answerRequiredPrompt", defaultMessage:"You must choose a value. If you would like to review this choice at the end of the questionnaire, bookmark this question with the button in the upper-right corner."})
      );
    } else {
      this.setState({ noteModalOpen: false });
      if (this.props.isLastQuestion) {
        this.setState({ waitForSave: true });
        this.props.saveResponse(this.props.response.metadata.id, e => {
          if (e) {
            this.setState({ saveErrors: e });
          } else {
            this.setState({ waitForSave: false });
            this.props.router.push(this.props.nextLink);
          }
        });
      } else {
        this.props.router.push(this.props.nextLink);
      }
    }
  }

  retrySaveResponse = () => {
    this.setState({saveErrors: null, waitForSave: true});
    this.props.saveResponse(this.props.response, e => {
      if (e) {
        this.setState({ saveErrors: e });
      } else {
        this.setState({ waitForSave: false });
        this.props.router.push(this.props.nextLink);
      }
    });
  }

  onPrevious = () => {
    this.saveNoteIfExists();
    this.setState({ noteModalOpen: false });
    this.props.router.push(this.props.previousLink);
  };

  saveNoteIfExists = () => {
    if (this.noteEditor) {
      this.handleSaveNote(this.noteEditor.getValue());
    }
  };

  onAnswerChange = (e, value) => {
    this.props.saveAnswer(
      this.props.question.id,
      value,
      this.props.sectionID,
      this.props.response
    );
  };

  handleSaveNote = value => {
    this.props.saveNote(this.props.question.id, value, this.props.response);
  };
}

let mapStateToProps = (state, ownProps) => {
  var isLeavingQuestionPage = /home/.test(state.route.locationBeforeTransitions.pathname) //no need to rerender if moving away from quesiton page, was causing a crash as response didn't exist
  if(isLeavingQuestionPage){
    return{
      leavingQuestionPage: true
    };
  }
  const isFinishing = ownProps.route.isFinishing;
  let questions = questionsForSection(state);
  let response = getResponse(state);
  let answers = response.answers;
  let questionID = ownProps.params.question;
  let question = questions.find(q => q.id.toString() === questionID);
  let position = questions.indexOf(question) + 1;
  if (isFinishing) {
    questions = questions.filter(
      q =>
        !answers[q.id] ||
        q.answers.map(a => a.id).indexOf(answers[q.id].value) === -1
    );
  } else {
    questions = questions.filter((q) => {
      let answer = answers[q.id];
      if (answer && answer.value && answer.answeredInSection !== ownProps.params.section) {
        return false;
      }
      return true;
    });
  }
  let isLastQuestion = false;
  if (!question) {
    alert(`Couldn't find question with id ${questionID}`);
  }
  let index = questions.indexOf(question);

  var previousLink =
    "/questionnaire/" +
    response.metadata.id +
    "/" +
    ownProps.params.section +
    "/";
  if (index > 0) {
    previousLink = previousLink + questions[index - 1].id;
  }
  var nextLink = `/questionnaire/${response.metadata.id}/`;
  if (isFinishing) {
    nextLink += "finish/";
  }
  if (index + 1 >= questions.length) {
    nextLink = `/home/${response.metadata.id}`;
    isLastQuestion = true;
  } else {
    nextLink =
      nextLink + ownProps.params.section + "/" + questions[index + 1].id;
  }
  if (index >= questions.length && state.sync.hasLoadedQDD) {
    ownProps.router.push(nextLink);
    return {
      questions: []
    };
  } else {
    let category = state.categories.find(c => c.id === question.category);

    //TODO: use shared naming structure
    var section = "Data Collection";
    if (ownProps.params.section === "assessment") {
      section = "Assessment";
    } else if (ownProps.params.section === "controlRules") {
      section = "Management Measures";
    } else if(ownProps.params.section === "enforcement") {
      section = "Enforcement";
    }
    const results = calculateResults(state.questions, response.answers, state.options, state.categories, state.tags);

    let translation = state.translations.find(t => t.id === response.userEdits.trIDForResponse)


    return {
      isFinishing: isFinishing || false,
      questions: questions,
      question: question,
      answers: answers,
      answer: answers[questionID],
      category: category,
      section,
      previousLink,
      nextLink,
      sectionID: ownProps.params.section,
      response,
      isLastQuestion: isLastQuestion,
      totalQuestionsInSection: results[ownProps.params.section].completedQuestions + results[ownProps.params.section].incompleteQuestions,
      totalAnswersInSection: results[ownProps.params.section].completedQuestions,
      position,
      translation,
      leavingQuestionPage:false
    };
  }
};

let mapDispatchToProps = dispatch => {
  return {
    toggleFlagged: (id, response, section) =>
      dispatch(toggleQuestionFlagged(id, response, section)),
    saveAnswer: (id, value, section, response) =>
      dispatch(saveAnswer(id, value, section, response)),
    saveNote: (id, value, response) =>
      dispatch(saveAnswerNote(id, value, response)),
    saveResponse: (responseID, callback) =>
      dispatch(putResponse(responseID, callback)),
    fetchTranslation: (id) => dispatch(fetchTranslation(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(injectIntl(QuestionPage))
);
